export const faqList = [
    {
        question: "Have you been vetted by the Police?",
        answer: "Yes, I have an up to date DBS (Disclosure and Barring Service) certificate."
    },
    {
        question: "Do you have a maths degree?",
        answer: "Yes, I have a BSc Hons degree in Mathematics from King's College, London."
    },
    {
        question: "When did you start tutoring?",
        answer: "I started a tutoring business over 10 years ago after tutoring my sons and niece at both GCSE and 'A' level. All three achieved A* grades at each level."
    },
    {
        question: "Are you a qualified teacher?",
        answer: "No, after leaving university I worked in law enforcement for 20+ years becoming a senior manager. I am reliable and trustworthy and have excellent communication skills. Furthermore, I have a proven track record of leadership and achievement and believe that these skills and abilities are transferable and key to becoming a great teacher."
    },
    {
        question: "Which maths specifications do you teach for 'A' level?",
        answer: "I teach Edexcel, AQA and OCR."
    },
    {
        question: "What sort of grades do your 'A' level students get?",
        answer: "If I tutor a student for a prolonged period they typically achieve a B or above although most will attain an A or A*. In 2019 one of my students (Illya) achieved an A* (92%) at 'A' level maths in one year, and went on to secure a place at Cambridge University to study maths. I often have students come to me after failing maths or not getting the grades they need and I have many examples of significant improvements in grades (see my reviews)."
    },
    {
        question: "Do you do virtual tutoring?",
        answer: "I prefer to deliver a lesson one-to-one in person, however, I can deliver lessons using Skype. This worked well during the Covid-19 outbreak."
    },
    {
        question: "How far are you prepared to travel to tutor?",
        answer: "If you reside within a 5 mile radius of Bessacarr, Doncaster I will travel to you at no cost. I am prepared to travel further afield but will include fuel expenses."
    },
    {
        question: "Do you issue homework?",
        answer: "Yes. Homework is issued after every lesson and it's very important that this is completed so that I and the student know that the topic is fully understood."
    },
    {
        question: "Do you do home schooling?",
        answer: "Yes. I have lots of experience of home tutoring and have even set up classrooms."
    },
    {
        question: "Would you be prepared to teach a small group of students for a reduced fee?",
        answer: "It depends. Can you please give me a call on 07432 263120 to discuss."
    },
    {
        question: "Would you recommend taking 'A' level further maths?",
        answer: "It depends. If you want to go to university to study a maths related degree I would recommend taking further maths, if not, take standard 'A' level maths. Further maths is much harder but some Russell Group universities prefer it."
    }
];